<ng-container *ngIf="(patientSectionMode$ | async) as patientSectionVersion">
  <rx-patient-read-only
    [hidden]="patientSectionVersion !== patientSectionVersionEnum.ReadOnly || (unifiedPatientsEnabled$ | async) !== false"
    [patient]="patient$ | async"
    [isIntuitiveFlow]="isIntuitiveFlow$ | async"
    [regulatoryDOBMask]="regulatoryDOBMask$ | async"
    [dateFormat]="dateFormat$ | async"
    [isEditButtonVisible]="isEditButtonVisibleForReadOnly$ | async"
    [isClearButtonVisible]="isClearButtonVisibleForReadOnly$ | async"
    [maxPatientLastNameLength]="maxPatientLastNameLength$ | async"
    [isButtonsVisible]="!(isRxFromReferralDoctorAndUserIsScannigCenter$ | async)"
    (patientCleared)="clearPatient()"
    (patientEdited)="editPatient()"
  >
  </rx-patient-read-only>
  <rx-patient-app-inline
    [hidden]="patientSectionVersion !== patientSectionVersionEnum.InlinePatientApp || (unifiedPatientsEnabled$ | async) !== false"
    [url$]="patientAppInlineUrl$"
    [isPatientInConflict]="isPatientInConflict$ | async"
    [isResizePatientAppDialog]="isResizePatientAppDialog$ | async"
  >
  </rx-patient-app-inline>
  <rx-unified-patient
    *ngIf="(unifiedPatientsEnabled$ | async) !== false"
  >
  </rx-unified-patient>
</ng-container>
